import { cn } from "@/lib/utils";
import { type Persona, personaContent } from "@/lib/persona-content";

const PERSONAS: Persona[] = ["individual", "team", "coach"];

interface PersonaSwitcherProps {
  persona: Persona;
  onChange: (persona: Persona) => void;
}

export function PersonaSwitcher({ persona, onChange }: PersonaSwitcherProps) {
  return (
    <div className="inline-flex items-center rounded-full bg-white/5 border border-white/10 p-1 gap-1">
      {PERSONAS.map((p) => {
        const content = personaContent[p];
        const Icon = content.icon;
        const isActive = p === persona;

        return (
          <button
            key={p}
            onClick={() => onChange(p)}
            className={cn(
              "flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200",
              isActive
                ? "bg-gradient-to-r from-primary/20 to-accent/20 border border-white/20 text-white shadow-sm"
                : "text-white/60 hover:text-white/80 border border-transparent"
            )}
          >
            <Icon className="w-3.5 h-3.5" />
            <span>{content.label}</span>
          </button>
        );
      })}
    </div>
  );
}
